import { render, staticRenderFns } from "./BottomPlotTransect.vue?vue&type=template&id=7e8bd3b4&scoped=true"
import script from "./BottomPlotTransect.vue?vue&type=script&lang=js"
export * from "./BottomPlotTransect.vue?vue&type=script&lang=js"
import style0 from "./BottomPlotTransect.vue?vue&type=style&index=0&id=7e8bd3b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8bd3b4",
  null
  
)

export default component.exports